interface UserMessageBubbleProps {
  content: string;
}

export function UserMessageBubble({ content }: UserMessageBubbleProps) {
  return (
    <div className="flex min-w-0 justify-end self-stretch">
      <div className="min-w-0 max-w-[90%] rounded-nv-card bg-nv-brand-subtle px-3.5 py-2.5">
        <p className="whitespace-pre-wrap break-words text-[14px] font-normal leading-[22.4px] text-nv-text-primary">
          {content}
        </p>
      </div>
    </div>
  );
}
